export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const USER_CLEAR = 'USER_CLEAR';
export const USER_CHANGE_REQUEST = 'USER_CHANGE_REQUEST';
